import {
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { useContext, useState } from 'react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import AdvancedSettingsParams from './AdvancedSettingsParams';
import { useNextStepAfterUpdate } from '../Wizard/Wizard.hooks';
import { TranscriptionDialogContext } from '../../../../..';

const useStyles = makeStyles()(() => ({
  text: {
    fontSize: '13px',
  },
}));

interface AdvancedSettingsProps {
  isRetranscribe: boolean;
}

const AdvancedSettings: React.FC<AdvancedSettingsProps> = ({ isRetranscribe }) => {
  const { t } = useTranslation();
  const next = useNextStepAfterUpdate();
  const { settings } = useContext(TranscriptionDialogContext);
  const [selectedOption, setSelectedOption] = useState<string>('no');
  const { classes } = useStyles();

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOption(event.target.value);
  };

  return (
    <div>
      <FormControl component="fieldset">
        <RadioGroup
          aria-label="advanced-settings"
          name="advanced-settings"
          value={selectedOption}
          className={classes.text}
          onChange={handleRadioChange}>
          <FormControlLabel
            value="no"
            id="btn_wizard_advanced_no"
            control={<Radio />}
            label={
              <Typography
                className={classes.text}
                dangerouslySetInnerHTML={{
                  __html: t('home.input.dialog.advanced.no', {
                    interpolation: {
                      escapeValue: false,
                    },
                  }),
                }}
              />
            }
          />
          <FormControlLabel
            value="yes"
            id="btn_wizard_advanced_yes"
            control={<Radio />}
            label={
              <Typography
                className={classes.text}
                dangerouslySetInnerHTML={{
                  __html: t('home.input.dialog.advanced.yes', {
                    interpolation: {
                      escapeValue: false,
                    },
                  }),
                }}
              />
            }
          />
        </RadioGroup>
      </FormControl>

      {selectedOption === 'yes' && <AdvancedSettingsParams />}
      {!isRetranscribe && (
        <div
          style={{
            textAlign: 'right',
          }}>
          <Button
            id="btn_wizard_advanced_next"
            onClick={() =>
              next({
                ...settings,
              })
            }
            variant="contained">
            {t('home.input.dialog.next')}
          </Button>
        </div>
      )}
    </div>
  );
};

export default AdvancedSettings;
